import { jsx, jsxs } from 'react/jsx-runtime';
import { useCallback } from 'react';
import classNames from 'classnames';
import { Input } from '../../Input/Input.es.js';
import { useFilterGroup } from '../FilterGroup.Context/index.es.js';

const FilterGroupMainButton = ({ isOpen, onClick })=>{
    const handleFilterButtonClick = useCallback(()=>{
        onClick();
    }, [
        onClick
    ]);
    const containerCss = classNames('cb-filter-group-main-button', {
        focused: isOpen
    });
    const { filters } = useFilterGroup();
    return jsx("div", {
        className: containerCss,
        children: jsx(Input, {
            emphasize: Object.keys(filters).length > 0,
            value: "Filter",
            children: jsxs(Input.Field.Button, {
                "data-testid": "main-button",
                onClick: handleFilterButtonClick,
                children: [
                    jsx(Input.Inline.Icon, {
                        align: "left",
                        name: "FilterSolid",
                        size: 20
                    }),
                    jsx(Input.Inline.Icon, {
                        align: "right",
                        className: "caret",
                        name: "ChevronDownSolid",
                        size: 20
                    })
                ]
            })
        })
    });
};
FilterGroupMainButton.displayName = 'FilterGroup.MainButton';

export { FilterGroupMainButton };
//# sourceMappingURL=FilterGroup.MainButton.es.js.map
